module.exports = __webpack_public_path__ + "static/media/SO.b6907d05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SO.svg
// module id = 2264
// module chunks = 7